import * as ActionTypes from "../actions/types";
import {
  AUTHORIZATION_CODE,
  CLIENT_CREDENTIALS,
} from "../constants/application";

const INITIAL_STATE = {
  oAuthRedirectUri: [],
  postLogoutRedirectUri: [],
  form: {},
};

function updateOAuthTag(state, action) {
  return {
    ...state,
    oAuthRedirectUri: action.payload || [],
  };
}

function updatePostLogoutTag(state, action) {
  return {
    ...state,
    postLogoutRedirectUri: action.payload || [],
  };
}

function updateCreateApplicationFormField(state, action) {
  return {
    ...state,
    form: {
      ...state.form,
      [action.payload.name]: action.payload.value,
    },
  };
}

function clearState() {
  return { ...INITIAL_STATE };
}

// The Core names the grant "Client Credentials" while the constant is "Client credentials", so an
// exact match left the box unticked on edit (and saving then dropped the grant). Saving already
// maps names case-insensitively (cycles/application.js).
const hasGrantType = (grantTypes, name) =>
  (grantTypes || []).some(
    (grantType) => (grantType || "").toLowerCase() === name.toLowerCase()
  );

function prepareEditApplication(state, action) {
  const { application } = action.payload;

  return {
    ...state,
    form: {
      applicationUuid: application.uuid,
      title: application.title,
      description: application.descriptionValue,
      organizationId: application.organizationId,
      authorizationCodeAllowed: hasGrantType(
        application.allowedGrantTypes,
        AUTHORIZATION_CODE
      ),
      clientCredentialsAllowed: hasGrantType(
        application.allowedGrantTypes,
        CLIENT_CREDENTIALS
      ),
      subscriptionIds: application.subscriptionIds || [],
      applicationStatus: application.applicationStatus,
      allowedGrantTypesWithIds: application.allowedGrantTypesWithIds || [],
    },
    postLogoutRedirectUri: application.postLogoutRedirectUri || [],
    oAuthRedirectUri: application.oauthRedirectUri || [],
  };
}

export const applicationForm = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.UPDATE_OAUTH_TAG]: updateOAuthTag,
    [ActionTypes.UPDATE_POST_LOGOUT_TAG]: updatePostLogoutTag,
    [ActionTypes.UPDATE_CREATE_APPLICATION_FORM_FIELD]:
      updateCreateApplicationFormField,
    [ActionTypes.CLEAR_APPLICATION_FORM_STATE]: clearState,
    [ActionTypes.PREPARE_EDIT_APPLICATION]: prepareEditApplication,
  },
};
